<template>
  <div class="dashboard-editor-container">

    <div class="top-header">
      <div class="top-title-box">
        <img class="header-logo" src="@/assets/images/logo.png" alt="">
        <div>
          奎文区综合性自助服务终端
        </div>
      </div>
    </div>
    <div class="content-box">
    <el-row :gutter="36" style="padding:16px 16px 0;margin-bottom:32px;margin-left: 0;margin-right: 0">
      <el-col :xs="24" :sm="24" :lg="7" style="margin-bottom: 13px;padding: 16px 16px 0;background-color: #00b0ff;border: 0.5px #143275 solid">
        <el-row style="margin-left: 15px;margin-bottom: 5px"><label style="color: #fff;font-size: 16px">点击次数</label></el-row>
        <el-table
            :data="clickRecord"
            style="width: 99.97%;--el-table-border-color: none;border-right: 1px #143275 solid;border-left: 1px #143275 solid;border-bottom: 1px #143275 solid;"
            :highlight-current-row="false"
            :header-cell-style="{ backgroundColor: '#143275', color: '#ffffff', fontSize: '14px', textAlign: 'center', borderLeft: '0.5px #154480 solid', borderBottom: '1px #154480 solid' }"
            :cell-style="{ color: '#fff', fontSize: '14px', textAlign: 'center', borderBottom: '0.5px #143275 solid', borderLeft: '0.5px #143275 solid' }"
            :row-style="{ color: '#fff', fontSize: '14px', textAlign: 'center', }" :row-class-name="tableRowClassName"
            empty-text="暂无数据" max-height="818">
          <el-table-column
              prop="fmac"
              label="机器mac地址"
              width="280">
          </el-table-column>
          <el-table-column
              prop="clickCount"
              label="点击次数"
          >
          </el-table-column>
        </el-table>
        <pagination :total="page1.total" :page.sync="page1.current" :limit.sync="page1.size" :page-sizes="[5, 10]" @pagination="onPageChange(1)" />
<!--        <pagination :current-page="page1.current" :total="page1.total" @change="onPageChange(1)"></pagination>-->
        <!--        <el-pagination-->
        <!--            @size-change="handleSizeChange"-->
        <!--            @current-change="handleCurrentChange"-->
        <!--            :current-page="currentPage"-->
        <!--            :page-sizes="[5, 10, 20, 50]"-->
        <!--            :page-size="pageSize"-->
        <!--            :total="clickTotal"-->
        <!--            layout="total, sizes, prev, pager, next, jumper">-->
        <!--        </el-pagination>-->
      </el-col>
      <el-col :xs="24" :sm="24" :lg="7" style="margin-bottom: 13px;padding: 16px 16px 0;background-color: #00b0ff;border: 0.5px #143275 solid">
        <el-row style="margin-left: 15px;margin-bottom: 5px"><label style="color: #fff;font-size: 16px">打印次数</label></el-row>
        <el-table
            :data="printRecord"
            style="width: 99.97%;--el-table-border-color: none;border-right: 1px #143275 solid;border-left: 1px #143275 solid;border-bottom: 1px #143275 solid;"
            :highlight-current-row="false"
            :header-cell-style="{ backgroundColor: '#143275', color: '#ffffff', fontSize: '14px', textAlign: 'center', borderLeft: '0.5px #154480 solid', borderBottom: '1px #154480 solid' }"
            :cell-style="{ color: '#fff', fontSize: '14px', textAlign: 'center', borderBottom: '0.5px #143275 solid', borderLeft: '0.5px #143275 solid' }"
            :row-style="{ color: '#fff', fontSize: '14px', textAlign: 'center', }" :row-class-name="tableRowClassName"
            empty-text="暂无数据" max-height="818">
          <el-table-column
              prop="fmac"
              label="机器mac地址"
              width="180">
          </el-table-column>
          <el-table-column
              prop="printCount"
              label="打印次数"
              >
          </el-table-column>
        </el-table>
        <pagination :total="page2.total" :page.sync="page2.current" :limit.sync="page2.size" :page-sizes="[5, 10]" @pagination="onPageChange(2)" />
<!--        <pagination :current-page="page2.current" :total="page2.total" @change="onPageChange(2)"></pagination>-->
        <!--        <el-pagination-->
        <!--            @size-change="handleSizeChange"-->
        <!--            @current-change="handleCurrentChange"-->
        <!--            :current-page="currentPage"-->
        <!--            :page-sizes="[5, 10, 20, 50]"-->
        <!--            :page-size="pageSize"-->
        <!--            :total="printTotal"-->
        <!--            layout="total, sizes, prev, pager, next, jumper">-->
        <!--        </el-pagination>-->
      </el-col>
      <el-col :xs="24" :sm="24" :lg="10" style="margin-bottom: 13px;padding: 16px 16px 0;background-color: #00b0ff;border: 0.5px #143275 solid">
        <el-row style="margin-left: 15px;margin-bottom: 5px"><label style="color: #fff;font-size: 16px">点击事项排名</label></el-row>
        <el-table
            :data="clickItem"
            style="width: 99.97%;--el-table-border-color: none;border-right: 1px #143275 solid;border-left: 1px #143275 solid;border-bottom: 1px #143275 solid;"
            :highlight-current-row="false"
            :header-cell-style="{ backgroundColor: '#143275', color: '#ffffff', fontSize: '14px', textAlign: 'center', borderLeft: '0.5px #154480 solid', borderBottom: '1px #154480 solid' }"
            :cell-style="{ color: '#fff', fontSize: '14px', textAlign: 'center', borderBottom: '0.5px #143275 solid', borderLeft: '0.5px #143275 solid' }"
            :row-style="{ color: '#fff', fontSize: '14px', textAlign: 'center', }" :row-class-name="tableRowClassName"
            empty-text="暂无数据" max-height="818">
          <el-table-column
              prop="fitemid"
              label="事项名称"
              width="280">
          </el-table-column>
          <el-table-column
              prop="clickCount"
              label="点击次数"
          >
          </el-table-column>
        </el-table>
        <pagination :total="page3.total" :page.sync="page3.current" :limit.sync="page3.size" :page-sizes="[5, 10]" @pagination="onPageChange(3)" />
<!--        <pagination :current-page="page3.current" :total="page3.total" @change="onPageChange(3)"></pagination>-->
        <!--        <el-pagination-->
        <!--            @size-change="handleSizeChange"-->
        <!--            @current-change="handleCurrentChange"-->
        <!--            :current-page="currentPage"-->
        <!--            :page-sizes="[5, 10, 20, 50]"-->
        <!--            :page-size="pageSize"-->
        <!--            :total="itemTotal"-->
        <!--            layout="total, sizes, prev, pager, next, jumper">-->
        <!--        </el-pagination>-->
      </el-col>
    </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PrintAndClickRecord',
  data() {
    return {
      page1: {
        current: 1,
        total: 0,
        size: 5,
      },
      page2: {
        current: 1,
        total: 0,
        size: 5,
      },
      page3: {
        current: 1,
        total: 0,
        size: 5,
      },
      currentPage: 1,
      pageSize: 10,
      // 预约取号主表格数据
      clickRecord: [],
      printRecord: [],
      clickItem: [],
      size: 10,
      pages: 1,
      // 总条数
      // clickTotal: 0,
      // printTotal: 0,
      // itemTotal: 0,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        status: '0',
        deptId: undefined
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      selectedValue: null,
    }
  },
  created() {
    this.getMachineClickRecordList();
    this.getMachinePrintRecordList();
    this.getItemClickRecordList();
  },
  methods: {
    onPageChange(pageIndex) {
      const page = this[`page${pageIndex}`];
      page.current = Math.max(1, Math.min(page.total, page.current));
      // 根据pageIndex执行分页逻辑
      if (pageIndex === 1) {
        this.getMachineClickRecordList();
      }
      if (pageIndex === 2) {
        this.getMachinePrintRecordList();
      }
      if (pageIndex === 3) {
        this.getItemClickRecordList();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return "error-row";
      } else {
        return "warning-row";
      }
    },
    /** 机器点击次数 */
    getMachineClickRecordList() {
      this.loading = true;
      this.$rqt.getMachineClickRecordList(this.page1.current, this.page1.size).then(res => {
        this.page1.total = res.data.total
        this.clickRecord = res.data.records
      })
    },
    /** 机器打印次数 */
    getMachinePrintRecordList() {
      this.loading = true;
      this.$rqt.getMachinePrintRecordList(this.page2.current, this.page2.size).then(res => {
        this.page2.total = res.data.total
        this.printRecord = res.data.records
      })
    },
    /** 日热门事项分析 */
    getItemClickRecordList() {
      this.loading = true;
      this.$rqt.getItemClickRecordList(this.page3.current, this.page3.size).then(res => {
        this.page3.total = res.data.total
        this.clickItem = res.data.records
      })
    },
  }
}
</script>
<style scoped lang="scss">
.content-box {
  height: calc(100vh - 42rem - 40px);
  padding: 20px 5rem;
}
// 顶部标题栏
.top-header {
  height: 20rem;
  background-color: #295eb5;
  padding: 3rem 8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .top-title-box {
    display: flex;
    align-items: center;
    font-size: 8rem;
    font-weight: bold;
    color: #ffffff;
    font-family: '汉仪中黑';
  }


  .header-logo {
    width: 20rem;
    height: 20rem;
    display: block;
    margin-right: 6rem;
  }
}

/* // 表格斑马自定义颜色 */
::v-deep .el-table__row.warning-row {
  background: #0e3b8f;
}

/* // 表格斑马自定义颜色 */
::v-deep .el-table__row.error-row {
  background: #00b0ff;
}

/* // 修改高亮当前行颜色 */
::v-deep .el-table tbody tr:hover>td {
  background: #0850ab !important;
}
</style>